import React from "react";
import { Col, Row } from "react-bootstrap";
import close from "../../assets/images/close.svg";

const InputDetail = ({ handleshowPopup, compObj, isDisable }) => {
  return (
    <div className="schedular-popup">
      <div className="popup-title">
        <h2>Detail</h2>
        <img
          src={close}
          alt="close"
          className="cursor-pointer"
          id="scheduler"
          onClick={(e) => {
            handleshowPopup(e);
          }}
          disabled={isDisable ? isDisable : false}
        />
      </div>
      <div className="popup-body">
        <Row>
          <Col xl={12} className="black-color-text">
            <div
              dangerouslySetInnerHTML={{
                __html: compObj?.details ? compObj?.details : "",
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default InputDetail;
